import React from "react";
import { Typography } from "antd";
import { useSelector } from "react-redux";

const { Text, Link } = Typography;

export default function PagesFooter() {
  const buildHash = useSelector((state) => state.buildHash);

  return (
    <div
      style={{
        paddingTop: "12vh",
        // backgroundColor: token.colorBgBase,
        textAlign: "center",
      }}
    >
      <Text>
        Criado por{" "}
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href="https://nupedido.com.br/?source=admin"
        >
          Nupedido
        </Link>
        © 2026 - Versão {buildHash ? buildHash.buildHash : "N/A"}
      </Text>
    </div>
  );
}
